import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: theme.typography.pxToRem(900),
  padding: theme.spacing(14, 8),
  flexDirection: 'column',
  justifyContent: 'flex-end',
  position: 'relative',
  [theme.breakpoints.down('xl')]: {
    height: '78.2vh',
  },
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(10, 0),
    height: theme.typography.pxToRem(768),
  },
  '& .FSBackgroundImage': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -2,
  },
  '& .FSOverlay': {
    position: 'absolute',
    inset: 0,
    zIndex: -1,
    background: `linear-gradient(
      0deg,
      ${theme.palette.background.primary} 6.11%,
      rgba(0, 0, 0, 0.00) 57.51%,
      ${theme.palette.background.primary} 109.95%
    )`,
  },
  '& .FSContent': {
    // flexDirection: 'column',
    // alignItems: 'flex-start',
    // justifyContent: 'flex-start',
    maxWidth: theme.typography.pxToRem(600),
  },
  '& .FSHeading': {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(3),
    },
  },
  '& .FSParagraph': {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
}));

export default StyledBox;
